import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  const getChangeIcon = (change: string) => {
    if (change === 'up') return <i className="ri-arrow-up-line text-accent-500 text-sm"></i>;
    if (change === 'down') return <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>;
    if (change === 'new') return <span className="text-xs text-primary-500 font-bold whitespace-nowrap">NEW</span>;
    return <i className="ri-subtract-line text-foreground-400 text-sm"></i>;
  };

  const getRankBadge = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-white';
    if (rank === 2) return 'bg-secondary-400 text-white';
    if (rank === 3) return 'bg-primary-400 text-white';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-14 md:py-18 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          热门排行
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          本周最受观众欢迎的影视作品榜单
        </p>
        <div className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, index) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-5 py-4 ${
                index < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-background-100 transition-colors cursor-pointer`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${getRankBadge(item.rank)}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground-900 truncate">{item.title}</p>
                <p className="text-xs text-foreground-500">{item.category}</p>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-sm font-bold text-primary-500 whitespace-nowrap">{item.score}</span>
                <span className="w-6 h-6 flex items-center justify-center">
                  {getChangeIcon(item.change)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}